<div class="profile-container">
    <div class="">
        <div class="profile-content">
            <div class="personal-details">
                <h4 class="personal-details-title">UPDATE TICKET-TYPE</h4>
                <table class="table table-striped">
                  <thead>
                    <tr>
                      <th scope="col">#</th>
                      <th scope="col">Ticket Type</th>
                      <th scope="col">Version</th>
                      <th scope="col">Publicly Visible</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let x of tickets ;let i = index">
                      <th scope="col">{{i+1}}</th>
                      <th scope="col">{{x.name}}</th>
                      <th scope="col">{{x.version}}</th>
                      <th scope="col">{{x.isPubliclyVisible}}</th>
                      <th>
                        <svg (click)="getTicketTypeById(x.ticketTypeId)" data-toggle="modal" data-target="#updateModal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16">
                            <path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/>
                            <path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/>
                        </svg> 
                      </th>
                    </tr>
                       
                  </tbody>
              </table>
            </div>
  
        </div>
    </div>
</div>
  
  
  <div class="modal fade" id="updateModal" tabindex="-1" data-backdrop="static" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">UPDATE TICKET TYPE
          <span data-dismiss="modal">
            <svg data-dismiss="modal" xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-x-lg" viewBox="0 0 16 16">
                <path d="M2.146 2.854a.5.5 0 1 1 .708-.708L8 7.293l5.146-5.147a.5.5 0 0 1 .708.708L8.707 8l5.147 5.146a.5.5 0 0 1-.708.708L8 8.707l-5.146 5.147a.5.5 0 0 1-.708-.708L7.293 8 2.146 2.854Z"/>
            </svg>
          </span>
        </h5>
      </div>
      <div class="modal-body">
  
        <div [formGroup]="editForm">
  
            <div class="form-group">
                <label>ticket-types</label>
                <input formControlName="name" type="text" class="form-control">
            </div>
  
            <div class="form-group">
                <label>Version</label>
                <input formControlName="version" type="text" class="form-control">
            </div>
  
            <div class="form-group">
                <label>Active status</label>
                <input type="checkbox" style="margin-left: 10px;" (click)="radiocheck()" formControlName="isActive">
            </div>

            <div class="form-group">
              <label>Service</label>
              <select class="form-control" aria-label="Default select example" formControlName="serviceType">
                <option [value]="service.name" *ngFor="let service of serviceData">{{service.name}}</option>
              </select>
            </div>

            <div class="form-group">
              <label>Publicly Visible</label>
              <select name="" id="" formControlName="isPubliclyVisible" class="form-control">
                <option value="true">True</option>
                <option value="false" selected>False</option>
              </select>
          </div>
  
        </div>
  
   
      <div class="modal-footer">
        <button type="button" id="closeModalButton"   class="btn btn-secondary" data-dismiss="modal">Cancel</button>
        <button type="button" (click)="updateTicketType()" class="btn btn-primary">save changes</button>
      </div>
    </div>
  </div>
  </div>
  </div>
  
 
